import { useState, useRef, useEffect } from 'react';
import { useAuth } from '../../../../../providers/auth';
import { useNavigate, NavLink } from 'react-router-dom';
import { useUser } from '../../../../../providers/database';
import { useGlobalState } from '../../../../../providers/globalState/GlobalStateProvider';

const ArchivePopup = ({ archivesAdminNavbarRoutes }: any) => {
    const [isOpen, setIsOpen] = useState(false);
    const { globalState, setGlobalState }: any = useGlobalState();
    const popupRef = useRef(null);
    const buttonRef = useRef(null);
    const auth = useAuth();
    const navigate = useNavigate();

    const togglePopup = () => {
        setIsOpen((prev:any) => !prev);
    };

    const handleClickOutside = (event: MouseEvent) => {
        if (
            popupRef.current &&
            !popupRef.current.contains(event.target as Node) &&
            buttonRef.current &&
            !buttonRef.current.contains(event.target as Node)
        ) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="relative inline-block text-left">
            {auth?.userClaims?.claims?.type === 'A' && (
                <button
                    type="button"
                    ref={buttonRef}
                    className="inline-flex justify-center outline-none items-center px-4 pl-10 py-2 bg-instant-teams-blue-Main text-white font-medium rounded-md shadow-sm hover:bg-instant-teams-teal-Main focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-instant-teams-blue-Main transition"
                    onClick={togglePopup}
                >
                    Archived
                    <svg
                        className={`ml-2 h-4 w-4 transition-transform ${isOpen ? 'rotate-180' : ''}`}
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                </button>
            )}
            {isOpen && (
                <div
                    ref={popupRef}
                    className="origin-top-right ml-[300px] absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50"
                >
                    <nav className="py-1">
                        {archivesAdminNavbarRoutes
                            .filter((route: any) =>
                                route.viewer.includes(auth?.userClaims?.claims?.role),
                            )
                            .map((link: any, idx: number) => (
                                <NavLink
                                    key={idx}
                                    to={link.link}
                                    onClick={() => {
                                        setGlobalState({
                                            ...globalState,
                                            pageTitle: link.name,
                                        });
                                        setIsOpen(false);
                                    }}
                                    className={({ isActive }: any) =>
                                        `block px-4 py-2 text-sm text-gray-700 hover:bg-instant-teams-blue-Main hover:text-white rounded transition ${isActive ? '' : ''}`
                                    }
                                >
                                    {link.name}
                                </NavLink>
                            ))}
                    </nav>
                </div>
            )}
        </div>
    );
};

export default ArchivePopup;
